// extracted by mini-css-extract-plugin
export default {"menu":"contracts_menu__U44x-","confirm":"contracts_confirm__hs-vW","confirmText":"contracts_confirmText__-eBwJ","confirmActions":"contracts_confirmActions__JG5LV"};